import script from "./AlbumModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AlbumModal.vue?vue&type=script&setup=true&lang=js"

import "./AlbumModal.vue?vue&type=style&index=0&id=740b3c64&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-740b3c64"]])

export default __exports__